import React from 'react'

function Bottom() {

    return (
        <section className="bottom">
            <h2>By The Numbers</h2>
            <div className="category">
                <div className="item">
                    <h2>500+</h2>
                    <p>Happy Members</p>
                </div>
                <div className="item">
                    <h2>20+</h2>
                    <p>Certified Trainers</p>
                </div>
                <div className="item">
                    <h2>50+</h2>
                    <p>Classes Offerd</p>
                </div>
            </div>
        </section>
    )
}

export default Bottom
